import { render, staticRenderFns } from "./full-table.vue?vue&type=template&id=6cbb5cd6"
import script from "./full-table.vue?vue&type=script&lang=js"
export * from "./full-table.vue?vue&type=script&lang=js"
import style0 from "./full-table.vue?vue&type=style&index=0&id=6cbb5cd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports